import {
    CREATE_IM_DFM_3D_SLIDE,
    DELETE_IM_DFM_3D_SLIDE,
    DUPLICATE_IM_DFM_3D_SLIDE,
    ImDfm3dSlideValuesType,
    DeleteImDfm3dSlideValuesType,
    UPDATE_IM_DFM_3D_SLIDE,
    UpdateImDfm3dSlideValuesType,
} from './reducer'

export const createImDfm3dSlide = (
    imDfm3dSlideValues: ImDfm3dSlideValuesType,
) =>
    ({
        type: CREATE_IM_DFM_3D_SLIDE,
        imDfm3dSlideValues,
    } as const)

export const deleteImDfm3dSlide = (
    deleteUnsaved3dDfmSlideValues: DeleteImDfm3dSlideValuesType,
) =>
    ({
        type: DELETE_IM_DFM_3D_SLIDE,
        deleteUnsaved3dDfmSlideValues,
    } as const)

export const duplicateImDfm3dSlide = (
    duplicateImDfm3dSlideValues: ImDfm3dSlideValuesType,
) =>
    ({
        type: DUPLICATE_IM_DFM_3D_SLIDE,
        duplicateImDfm3dSlideValues,
    } as const)

export const updateImDfmSlide = (
    updateImDfm3dSlideValues: UpdateImDfm3dSlideValuesType,
) =>
    ({
        type: UPDATE_IM_DFM_3D_SLIDE,
        updateImDfm3dSlideValues,
    } as const)
